<template>
  <div>
    <catalog-head-outer></catalog-head-outer>
    <catalog-main></catalog-main>
    <news-module>
      <template #title>Акции и скидки</template>
    </news-module>
    <products-carousel :items="watched" v-if="watched && watched.length > 0">
      <template #title>Вы просматривали</template>
    </products-carousel>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CatalogHeadOuter from '../../components/modules/Catalog/CatalogHeadOuter'
import CatalogMain from '../../components/modules/Catalog/CatalogMain'
import NewsModule from '../../components/modules/News/NewsModule'
import ProductsCarousel from '../../components/modules/ProductsCarousel/ProductsCarousel'
// import titleMixin from '../../mixins/titleMixin'
// import pageClassMixin from '../../mixins/pageClassMixin'
export default {
  name: 'CatalogPage',
  metaInfo () {
    return {
      title: 'Каталог'
    }
  },
  pageClass: 'catalog-page',
  components: {
    CatalogHeadOuter,
    CatalogMain,
    NewsModule,
    ProductsCarousel
  },
  computed: {
    ...mapState('blocks', ['watched'])
  },
  methods: {
    ...mapActions('blocks', ['getWatched']),
    prepare () {
      this.getWatched()
    }
  },
  created () {
    this.prepare()
  }
}
</script>

<style scoped>

</style>
